export default __webpack_public_path__ + "static/media/SO.ee1cc5cb.svg";